export const settingsSidebarSoftware = [
  {
    heading: 'Программное обеспечение',
    navlinks: {
      // 'software-releases': 'Выпуски ПО',
      'software-app-version': 'Версия приложения',
    },
  },
];
